import React, { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Dashboard from './components/Dashboard';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);

  const toggleTheme = () => setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  const handleLogin = (user) => setIsAuthenticated(user);
  const handleLogout = () => setIsAuthenticated(false);

  return (
    <BrowserRouter>
      {isAuthenticated ? (
        <Dashboard
          theme={theme}
          toggleTheme={toggleTheme}
          onLogout={handleLogout}
          user={isAuthenticated}
        />
      ) : (
        <LandingPage
          theme={theme}
          toggleTheme={toggleTheme}
          onLogin={handleLogin}
        />
      )}
    </BrowserRouter>
  );
}

export default App;
